module.exports = __webpack_public_path__ + "img/advantage3.19f4eebd.png";